// extracted by mini-css-extract-plugin
module.exports = {"container":"GridMoreBaseMapsItem_container__Z4KdJ","image":"GridMoreBaseMapsItem_image__NjDYM","textContainer":"GridMoreBaseMapsItem_textContainer__waaBD"};